<template>
  <div class="header">
    <div class="topAdvAreaWrap" v-show="isTop">
      <div class="sideForms" @click="useCustomerService"></div>
      <!-- <div class="top_adv_close" @click="closeTop">
        <img src="@/assets/home/关闭.png" alt="">
      </div> -->
    </div>
    <div class="topNav">
      <div class="overflowCenter">
        <img src="../assets/logo-black.png" alt="" class="logo" />
        <span> | 专注上岸的网校 </span>
        <ul class="navList">
          <li v-for="(item, index) in navList" :key="index" @click="navBtn(item)"
            :class="[item.name == route.name ? 'active' : '']">
            {{ item.title }}
          </li>
        </ul>
        <p>服务热线：<span>400-188-6865</span></p>
        <img src="@/assets/image/phone.png" class="phone" alt="">
      </div>
    </div>
    <!-- <img src="//30594067.s21i.faimallusr.com/2/ABUIABACGAAg-IjWnwYozMelnAcwgA842AQ.jpg" alt=""
      class="homeBanner" @click="useCustomerService" /> -->
    <!-- <img src="@/assets/home/bannerOne.png" class="homeBanner" @click="useCustomerService" alt=""> -->
  </div>
</template>

<script setup>
import { navList } from "../api/navList";
import { useCustomerService } from '@/api/common.js';
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
const isTop = ref(false)

// const closeTop = () => {
//   isTop.value = false;
// }

const router = useRouter();
const route = useRoute();
console.log(route, 'route')
function scrollToTop() {
  const currentPosition = document.documentElement.scrollTop;
  if (currentPosition > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, currentPosition - currentPosition / 10);
  }
}
scrollToTop();
const navBtn = (item) => {
  router.push(item.path)
  scrollToTop();
  // window.open(item.path, '_blank')
};
</script>

<style scoped lang="scss">
.active {
  color: red;
  font-weight: bold;
  font-size: 20px;
}

.header {
  min-width: 1250px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
  .topAdvAreaWrap {
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
    background: url("../assets/topBgc.png") no-repeat 0 0;

    .sideForms {
      width: 1200px;
      height: 85px;
    }

    .top_adv_close {
      z-index: 8;
      position: absolute;
      top: 24px;
      right: 65px;
      width: 35px;
      height: 35px;
      cursor: pointer;

      img {
        width: 35px;
        height: 35px;
      }
    }
  }

  .topNav {
    width: 100%;
    height: 80px;
    background: #fff;
    display: flex;
    justify-content: center;
  }

  .overflowCenter {
    width: 1270px;
    // background: red;
    // margin-left: 267px;
    // margin-left: 287px;
    display: flex;

    .logo {
      margin-top: 8px;
      width: 200px;
      height: 65px;
    }

    span {
      // color: rgb(255, 235, 60);
      color: red;
      line-height: 85px;
      padding-left: -20px;
      cursor: default;
    }

    ul {
      display: flex;
      margin-left: 35px;
      // width: 80%;

      li {
        margin: 0 0px;
        margin-right: 25px;
        line-height: 85px;
        // color: white;
        cursor: pointer;
      }
    }

    P {
      // color: white;
      font-size: 20px;
      margin-left: 25px;
    }
    .phone {
      width: 50px;
      height: 50px;
      margin-top: 15px;
      margin-left: 10px;
    }
  }
}
</style>
